import React from 'react';
import { BarChart3Icon, ClipboardListIcon, MapIcon, SearchIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
import { toolkit } from '../data/content';
const icons = {
  search: SearchIcon,
  map: MapIcon,
  chart: BarChart3Icon,
  zap: ZapIcon,
  clipboard: ClipboardListIcon
};
export function Toolkit() {
  return <section className="border-t border-line bg-panel px-4 py-16 sm:py-20" aria-label="Diagnostic toolkit" data-id="element-313" data-mp="aux1wyip99g7">
      <div className="mx-auto max-w-4xl" data-id="element-314" data-mp="5vlhnfj4jltv">
        <SectionHeading kicker="Your complete diagnostic toolkit" title={<>
              Practical tools to <span className="text-amber" data-id="element-316" data-mp="fv2o3z67a3qw">apply what you learn</span>
            </>} subtitle="Not another technical ebook you read once and forget — resources you consult while organizing real diagnostic investigations." data-id="element-315" data-mp="5yps2un6ndsz" />

        <ul className="space-y-3" data-id="element-317" data-mp="2ho0ja1ng98f0">
          {toolkit.map(t => {
          const Icon = icons[t.icon];
          return <li key={t.title} className="flex items-start gap-4 rounded-2xl bg-panel2 p-5" data-id="element-318" data-mp="241shzzn0c7rg">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-amber" data-id="element-319" data-mp="290vntmatai0h">
                  <Icon className="h-6 w-6 text-ink" strokeWidth={2.5} aria-hidden="true" data-id="element-320" data-mp="2drc0h46t5zls" />
                </span>
                <div data-id="element-321" data-mp="2ir877b6w4551">
                  <h3 className="font-display text-2xl font-bold uppercase leading-tight text-white" data-id="element-322" data-mp="2ipndtowbas8r">{t.title}</h3>
                  <p className="mt-1 text-[15px] leading-relaxed text-mist" data-id="element-323" data-mp="2no8cvkztv5vm">{t.body}</p>
                </div>
              </li>;
        })}
        </ul>

        <p className="mt-8 text-center font-display text-2xl font-bold uppercase text-white" data-id="element-324" data-mp="2wqpzi0jea0j5">
          One structured collection. <span className="text-amber" data-id="element-325" data-mp="xenhkuqf5e7l">Multiple practical applications.</span>
        </p>

        <CtaButton className="mt-8" label="I want the complete toolkit" sub="Everything for a one-time $27" data-id="element-326" data-mp="12dhxnox04oo0" />
      </div>
    </section>;
}